import root from 'window-or-global';

export const getLocationPath = () => {
    try {
        return root && root.sessionStorage.getItem('LAST_KNOWN_LOCATION_PATH');
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const setLocationPath = (to?: string) => {
    try {
        return root && root.sessionStorage.setItem('LAST_KNOWN_LOCATION_PATH', to);
    } catch (err) {
        console.error(err);
        return null;
    }
};
